// extracted by mini-css-extract-plugin
export default {"form":"FfAZr","button":"BrZCG","errorMessage":"QRTVQ","infoText":"Uk9MJ","passwordIcon":"xWhs5","forgotPasswordLink":"Njv6k","moreInfo":"V88Fw","moreInfoContainer":"Fk1Be"};